/*
 * Reflect Shopify automatic discounts in the program/CE form's displayed price.
 * Asks the Storefront API for the real (post-automatic-discount) price using a
 * throwaway cart — non-destructive, reflects ANY active automatic discount, no
 * hardcoding or syncing. Shows the discounted price with the original struck through.
 */
(function () {
  var el = document.querySelector('.ho-prog-page-price');
  if (!el) return;
  var vid = el.getAttribute('data-vid');
  if (!vid) return;

  var TOKEN = '0f2bda8a0f86a3a6ebd9889157215828'; // public Storefront access token
  var ENDPOINT = 'https://healing-oasis-us.myshopify.com/api/2026-01/graphql.json';
  var QUERY = 'mutation($id:ID!){cartCreate(input:{lines:[{merchandiseId:$id,quantity:1}]}){cart{lines(first:1){nodes{cost{subtotalAmount{amount}totalAmount{amount}}}}}}}';

  fetch(ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': TOKEN
    },
    body: JSON.stringify({ query: QUERY, variables: { id: 'gid://shopify/ProductVariant/' + vid } })
  })
    .then(function (r) { return r.json(); })
    .then(function (d) {
      var cart = d && d.data && d.data.cartCreate && d.data.cartCreate.cart;
      var line = cart && cart.lines && cart.lines.nodes && cart.lines.nodes[0];
      if (!line) return;
      var sub = parseFloat(line.cost.subtotalAmount.amount); // base
      var tot = parseFloat(line.cost.totalAmount.amount);    // after automatic discounts
      if (isNaN(sub) || isNaN(tot) || tot >= sub - 0.001) return; // no discount → leave as-is
      var fmt = function (n) { return '$' + n.toFixed(2); };
      el.innerHTML =
        '<span style="text-decoration:line-through;color:#9aa3ad;font-weight:400;font-size:0.7em;margin-right:10px;">' +
        fmt(sub) + '</span>' + fmt(tot);
    })
    .catch(function () { /* leave base price on any error */ });
})();
